var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgTangoLogoNew = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 127,
  height: 48,
  fill: "none",
  viewBox: "0 0 127 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-1586663173__a)",
  d: "M35.82 14.158c-1.357.34-6.106 1.018-8.311 1.315-2.078 1.795-5.478 5.309-2.46 5.003 3.774-.381 9.626-1.653 12.255-2.544 1.399-.474 1.624-2.202.933-3.095-.608-.786-1.623-.877-2.417-.679"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-1586663173__b)",
  d: "M7.876 18.738c.584 3.066 5.456 3.024 7.845 2.756-1.074 1.597-3.375 6.055-3.986 11.11-.763 6.317 3.604 12.77 11.788 12.424 6.997-.297 13.145-6.658 16.452-10.77 3.308-4.114.976-7.379-.297-8.609s-5.427-2.671-8.353 2.163-6.954 8.056-9.413 7.42-.848-5.47 0-7.42 7.505-14.714 9.074-18.19c2.332-4.453-1.924-8.358-5.512-5.852a573 573 0 0 1-14.205 9.582c-1.837 1.191-3.977 2.32-3.393 5.386"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-1586663173__c)",
  d: "m25.606 20.415.096-.19c.817-1.606 1.669-3.282 2.455-4.84 2.379-.328 6.427-.918 7.663-1.227.793-.198 1.81-.107 2.417.679.69.893.466 2.621-.933 3.095-2.503.848-7.927 2.042-11.698 2.483"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#svg-1586663173__d)",
  d: "M9.75 20.906c3.469-.75 7.031-2.906 9.406-4.84-1.625 2.59-3.406 5.403-3.406 5.403-1.145.127-3.795.328-6-.563"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M56.852 13.624c-1.32 1.513-1.93 2.063-3.375 3.026-1.746 1.163-2.677 1.28-3.375 1.862-.626.521-.673 1.472-.466 2.095.336 1.006 1.862 1.163 2.923 1.095-.908 1.598-1.515 3.692-1.76 5.237-.529 3.343 1.02 5.77 5.189 5.155 1.283-.19 3.328-1.19 4.356-2.526 1.164-1.513.698-2.843-.35-3.608-.736-.537-1.683-.18-2.402.603-.623.677-1.205 1.344-1.995 1.125-1.603-.445 1.198-6.248 1.198-6.248s3.486-.346 4.986-.909c.938-.351 1.547-1.619 1.032-2.437-.289-.457-.875-.756-1.407-.657-1.5.282-3.062.544-3.062.544s.8-1.705 1.069-2.379c.742-1.862-1.35-3.364-2.56-1.978M67.56 21.313c-.535.365-1.27.394-1.729-.063l-.42-.416c-.558-.545-.562-1.501.084-1.938a9.86 9.86 0 0 1 4.287-1.614c1.47-.196 2.932-.133 4.36.287.665.196 1.274.511 1.778 1.008.553.553.833 1.239.924 2.009.105.854-.07 1.68-.252 2.505-.534 2.481-1.073 4.962-1.602 7.443a1.364 1.364 0 0 1-1.326 1.092h-.168l-1.168.002a1.207 1.207 0 0 1-1.206-1.224c.002-.193.004-.377.004-.524-.021.014-.05.014-.063.028-1.127 1.029-2.471 1.581-3.948 1.861-.798.154-1.61.21-2.414.07-1.113-.195-2.037-.7-2.583-1.735-.371-.707-.434-1.463-.336-2.247.23-1.812 1.302-3.002 2.856-3.821 1.126-.595 2.491-1.054 3.737-1.3 1.365-.272 2.583-.303 3.969-.373.181-.007.244-.07.258-.252.091-1-.476-1.714-1.525-1.847-1.314-.162-2.486.348-3.517 1.05m4.412 3.57a28 28 0 0 0-2.092.238c-.826.133-1.631.35-2.38.735-.434.224-.833.496-1.113.91-.703 1.05.126 1.878 1.406 1.674 1.746-.28 3.84-1.397 4.18-3.557M92.24 34.635c-.575-.686-.252-1.686.538-2.107l.731-.39c.698-.372 1.51-.135 2.1.39.53.47 1.145.798 1.872.88 1.519.167 2.751-.337 3.569-1.68.343-.553.567-1.155.749-1.792-.301.168-.581.343-.882.476-1.371.595-2.806.805-4.269.448-1.967-.476-3.178-1.771-3.73-3.689-.385-1.322-.308-2.666.007-3.989.343-1.435 1-2.708 2.036-3.765 1.162-1.19 2.569-1.918 4.22-2.142 1.17-.16 2.303-.042 3.381.462q.943.44 1.645 1.225c.049.049.091.098.161.175.079-.198.157-.428.235-.666a1.735 1.735 0 0 1 1.667-1.19h1.064a1.39 1.39 0 0 1 1.362 1.68 91 91 0 0 1-.304 1.387q-1.047 4.567-2.106 9.133c-.315 1.365-.784 2.666-1.526 3.863-1.218 1.967-2.982 3.114-5.263 3.457-1.463.217-2.919.203-4.34-.252a6 6 0 0 1-2.916-1.914m7.509-6.792c.21-.028.426-.042.636-.084.91-.196 1.554-.77 2.023-1.54.525-.853.777-1.805.847-2.799a3.25 3.25 0 0 0-.182-1.393c-.441-1.182-1.547-1.567-2.68-1.434-.84.098-1.512.532-2.03 1.182-.89 1.12-1.225 2.415-1.071 3.815.147 1.413 1.085 2.24 2.457 2.253M117.399 17.178c.973 0 2.184.217 3.297.825 1.595.868 2.582 2.22 2.897 3.99.49 2.75-.161 5.235-2.051 7.327-1.182 1.316-2.708 2.05-4.437 2.373-1.337.252-2.674.266-4.003-.07-1.666-.42-3.017-1.295-3.899-2.814-.56-.965-.791-2.022-.791-3.128.007-1.722.427-3.331 1.33-4.801 1.155-1.876 2.849-2.981 4.983-3.45.791-.175 1.582-.245 2.674-.252m1.799 6.243c-.042-.386-.07-.777-.14-1.162-.105-.581-.315-1.113-.77-1.512-.623-.553-1.372-.658-2.163-.51-.84.16-1.463.657-1.925 1.35-1.049 1.588-1.343 3.338-1.035 5.193.091.574.329 1.106.77 1.497.755.665 1.637.707 2.54.392.819-.287 1.372-.91 1.792-1.644.644-1.113.889-2.324.931-3.604M77.646 31.617a1.167 1.167 0 0 1-1.138-1.417c.845-3.847 1.689-7.812 2.529-11.648a1.63 1.63 0 0 1 1.59-1.278h1.082c.772 0 1.319.619 1.21 1.382-.027.188-.046.37-.046.537.084-.063.133-.098.175-.133 1.197-1.008 2.562-1.645 4.122-1.833.938-.113 1.862-.064 2.758.265 1.14.42 1.806 1.253 2.058 2.429.217 1.015.126 2.023-.084 3.016-.484 2.3-1.112 5.48-1.555 7.436a1.56 1.56 0 0 1-1.537 1.208h-1.773a1.16 1.16 0 0 1-1.133-1.413l.048-.215c.495-2.223.996-4.442 1.484-6.666.112-.51.161-1.035.021-1.56-.16-.602-.587-.966-1.21-1.015-1.372-.12-2.422.44-3.178 1.567-.504.756-.756 1.61-.938 2.485q-.582 2.744-1.173 5.492l-.02.093a1.62 1.62 0 0 1-1.588 1.27z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1586663173__a",
  x1: 38.576,
  x2: 23.82,
  y1: 14.964,
  y2: 18.61,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FD00CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FD00CF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1586663173__b",
  x1: 15.572,
  x2: 37.332,
  y1: 7.573,
  y2: 41.493,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.066,
  stopColor: "#FF0451"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.207,
  stopColor: "#FF006A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.378,
  stopColor: "#FC1FA4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.544,
  stopColor: "#FE00CF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.816,
  stopColor: "#B30CE4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8204FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1586663173__c",
  x1: 11.25,
  x2: 31.595,
  y1: 17.813,
  y2: 25.462,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.065,
  stopColor: "#92077F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#8D067D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.678,
  stopColor: "#8D008C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#8E067E",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "svg-1586663173__d",
  x1: 11.25,
  x2: 31.595,
  y1: 17.813,
  y2: 25.462,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.065,
  stopColor: "#92077F",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.285,
  stopColor: "#8D067D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.678,
  stopColor: "#8D008C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.912,
  stopColor: "#8E067E",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTangoLogoNew);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };